module.exports = {"connect_with":"Or connect with","success":{"title":"Connected with {{ providerName }} successfully","content":"There are just a few questions left to get you started. Almost done!","continue":"Continue"}}


//////////////////
// WEBPACK FOOTER
// ./src/locales/i18next/en/social.json
// module id = 545
// module chunks = 245 953